/**
 * Product Details Sheet Component
 *
 * Action sheet overlay showing detailed product information on mobile.
 */

import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { ProductDetailTab } from '@/components/MedicalOnDemand/ProductDetailTab';
import { MobileSheetHeader } from '@/components/MedicalOnDemand/mobile/MobileSheetHeader';
import {
  Actionsheet,
  ActionsheetBackdrop,
  ActionsheetContent,
  ActionsheetDragIndicator,
  ActionsheetDragIndicatorWrapper,
  ActionsheetScrollView,
} from '@/components/ui/actionsheet';
import { VStack } from '@/components/ui/vstack';
import type { Product } from '@/constants/medicalOnDemand';

type ProductDetailsSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  product: Product | null;
};

export function ProductDetailsSheet({ isOpen, onClose, product }: ProductDetailsSheetProps) {
  const insets = useSafeAreaInsets();

  if (!product) {
    return null;
  }

  return (
    <Actionsheet isOpen={isOpen} onClose={onClose}>
      <ActionsheetBackdrop />
      <ActionsheetContent style={{ paddingBottom: insets.bottom }} className="max-h-[85vh]">
        <ActionsheetDragIndicatorWrapper>
          <ActionsheetDragIndicator />
        </ActionsheetDragIndicatorWrapper>

        <VStack className="w-full px-4 pb-4">
          <MobileSheetHeader
            title="Product Details"
            onClose={onClose}
            className="mb-4"
            closeIconSize="sm"
          />

          <ActionsheetScrollView>
            <ProductDetailTab product={product} />
          </ActionsheetScrollView>
        </VStack>
      </ActionsheetContent>
    </Actionsheet>
  );
}
